module.exports = __webpack_public_path__ + "static/media/credit-card-expired.91403f79.svg";